import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { skills } from '../data/skills';
import { en } from '../i18n/en';
import { nl } from '../i18n/nl';
export default function Skills({ lang }) {
    const t = lang === 'nl' ? nl.skills : en.skills;
    return (_jsxs("section", { id: "skills", className: "py-8", children: [_jsx("h2", { className: "text-2xl font-semibold mb-10", children: t.title }), _jsx("div", { className: "flex flex-wrap gap-3", children: skills[lang].map((s) => (_jsx("span", { className: "rounded-full bg-slate-100 dark:bg-slate-800 px-4 py-2 text-sm text-slate-700 dark:text-slate-300", children: s }, s))) })] }));
}
